/* Tante Rie - close submenu on scroll
   On scroll: add body.tr-menu-force-closed (CSS hides submenu).
   On next mouse movement: remove class, allow submenu open again. */
(function () {
  let suppressed = false;

  function suppress() {
    if (!suppressed) {
      document.body.classList.add('tr-menu-force-closed');
      suppressed = true;
    }
  }

  function release() {
    if (suppressed) {
      document.body.classList.remove('tr-menu-force-closed');
      suppressed = false;
    }
  }

  window.addEventListener('scroll', suppress, { passive: true });
  document.addEventListener('mousemove', release, { passive: true });
  document.addEventListener('touchstart', release, { passive: true });
})();
